import type { ProductData, CompetitorProduct } from '../../../pages/competitor/match-sku/models/types';
import type { CompetitorClient, InsertCompetitorProductRequest } from '../../../infrastructure/CompetitorClient';

export const useInsertCompetitorProduct = (
  competitorClient: CompetitorClient,
  selectedProduct: ProductData,
  onProductDataUpdate: (updatedProduct: ProductData) => void,
  setActiveCompetitor: (competitor: string | null) => void,
) => {
  const handleInsert = async (data: InsertCompetitorProductRequest): Promise<void> => {
    try {
      await competitorClient.insertCompetitorProduct(data);

      const updatedProductData = { ...selectedProduct };

      const convertedProducts: CompetitorProduct[] = data.products.map((product) => ({
        ...product,
        possibility: 1,
        modifiedAt: new Date().toISOString(),
        category: Array.isArray(product.category) ? product.category.join(', ') : product.category,
        size: product.size || '',
        pack: product.pack || '',
        normalizedName: product.name,
        productImageUrls: Array.isArray(product.productImageUrls)
          ? product.productImageUrls.join(', ')
          : product.productImageUrls || '',
      }));

      const competitorIndex = updatedProductData.machineMatchedProducts.findIndex(
        (comp) => comp.competitor === data.competitor,
      );

      if (competitorIndex >= 0) {
        const competitor = updatedProductData.machineMatchedProducts[competitorIndex];
        if (competitor) {
          competitor.competitorProducts = [...(competitor.competitorProducts || []), ...convertedProducts];
        }
      } else {
        updatedProductData.machineMatchedProducts.push({
          competitor: data.competitor,
          competitorProducts: convertedProducts,
        });
      }

      onProductDataUpdate(updatedProductData);
      setActiveCompetitor(data.competitor);
    } catch (error) {
      console.error('Error inserting competitor product:', error);
    }
  };

  return { handleInsert };
};
